export default "__VITE_ASSET__DHW_OB_a__"